import React from 'react';
import Done from "@material-ui/icons/Done";
import Create from "@material-ui/icons/Create";
import ArrowForward from "@material-ui/icons/ArrowForward";
import ArrowBack from "@material-ui/icons/ArrowBack";
import FolderOpen from "@material-ui/icons/FolderOpen";
import Tooltip from '@material-ui/core/Tooltip';
import Chip from '@material-ui/core/Chip';
import Email from '@material-ui/icons/Email';
import { Typography } from '@material-ui/core';
import { ChevronRight, Check, Close } from '@material-ui/icons';

const styles = {
    clickable: {
        cursor: "pointer"
    }
}

const glosasRCV = [
    {"Codigo":"NCA","Nombre":"Recepción de NC de Anulación que Referencia Documento"},
    {"Codigo":"AUT","Nombre":"No Reclamado en el Plazo"},
    {"Codigo":"RFP","Nombre":"Reclamo por Falta Parcial de Mercaderías "},
    {"Codigo":"RFT","Nombre":"Reclamo por falta total de mercaderías"},
    {"Codigo":"ERM","Nombre":"Acuse de Recibo de Mercaderías y Servicios Ley 19.983"},
    {"Codigo":"ACD","Nombre":"Acepta Contenido del Documento"},
    {"Codigo":"RCD","Nombre":"Reclamo al contenido del documento"},
    {"Codigo":"CED","Nombre":"Cedido"},
    {"Codigo":"PAG","Nombre":"Pagado al Contado"},
    {"Codigo":"CON","Nombre":"Pagado al Contado"},
    {"Codigo":"RCD","Nombre":"Reclama Contenido del Documento"},
    {"Codigo":"ENC","Nombre":"Recepción de NC Distinta de Anulación"}
]

export function Estado(estado, rcv, onClick = undefined){
    rcv = (glosasRCV.find(k => k.Codigo==rcv)||{}).Nombre
    rcv = rcv?` (${rcv})`:"";
    if(/procesado/gi.test(estado) || /acepta/gi.test(estado)){
        estado = "Correcto";
    }
    if(/reparo/gi.test(estado)){
        estado = "Con Reparos";
    }
    if(/rechazado/gi.test(estado) || /invalid/gi.test(estado)){
        estado = "Rechazado";
    }
    switch(estado){
        case "Creado":
        case "Borrador":
        case "Guardado":{
            return (<Tooltip title={"Borrador"}>
                        <Create onClick={onClick} style={ onClick ? styles.clickable : {} } />
                    </Tooltip>)       
        }
        case "Envío Generado":{
            return (<Tooltip title={"En Proceso de Envío al SII"+rcv}>
                        <ArrowForward onClick={onClick} style={ {color:"orange", cursor:onClick?"pointer":"auto"} } />
                    </Tooltip>)       
        }
        case "Enviado":{
            return (<Tooltip title={"Enviado al SII"+rcv}>
                        <ArrowForward onClick={onClick} style={ onClick ? styles.clickable : {} } />
                    </Tooltip>)       
        }
        case "Recibido":{
            return (<Tooltip title={"Recibido de Proveedor y en el SII"+rcv}>
                        <ArrowBack onClick={onClick} style={ onClick ? styles.clickable : {} } />
                    </Tooltip>)       
        }
        case "Recibido en el SII":{
            return (<Tooltip title={"Recibido en el SII"+rcv}>
                        <ArrowBack onClick={onClick} style={ {color:"orange", cursor:onClick?"pointer":"auto"} } />
                    </Tooltip>)       
        }
        case "No recibido en el SII":{
            return (<Tooltip title={"Recibido de Proveedor"+rcv}>
                        <Email onClick={onClick} style={ {color:"orange", cursor:onClick?"pointer":"auto"} } />
                    </Tooltip>)       
        }
        case "Correcto":
        case "Aceptado":{
            return (<Tooltip title={"Aceptado por el SII"+rcv}>
                        <Done style={{color:"green", cursor:onClick?"pointer":"auto"}} onClick={onClick} />
                    </Tooltip>)       
        }
        case "Con Reparos":{
            return (<Tooltip title={"Aceptado por el SII Con Reparos"+rcv}>
                        <Done style={{color:"orange", cursor:onClick?"pointer":"auto"}} onClick={onClick} />
                    </Tooltip>)       
        }
        case "Rechazado":{
            return (<Tooltip title={"Rechazado por el SII"+rcv}>
                        <Close style={{color:"rojo", cursor:onClick?"pointer":"auto"}} onClick={onClick} />
                    </Tooltip>)       
        }
        case "Externo":{
            return (<Tooltip title={"Creado en Otro Sistema"+rcv}>
                        <FolderOpen onClick={onClick} style={ onClick ? styles.clickable : {} }/>
                    </Tooltip>)       
        }
    }
}

export function TipoDoc(tipo, type, etiquetas){
    var color = tipo ? (tipo.toLowerCase().includes("factura")?"#4caf50":
                    tipo.toLowerCase().includes("boleta")?"#2196f3":
                        tipo.toLowerCase().includes("nota")?"#ff5722":
                            tipo.toLowerCase().includes("guia")?"#9500ae":null) : null;
    return type == "text" ? 
    <span>
         { tipo }
    </span>
    :
    <>
    <Chip
        label={tipo}
        style={color?{color:color, borderColor:color}:null}
        variant="outlined"
      />
      {etiquetas?.filter(e => e.b_activo).map(e => <>&nbsp;<Chip
        label={e.nombre}
        color="primary"
        style={{backgroundColor:"#"+e.color, height:20}}
      /></>)}
      </>
}

export function EstadoTarea(tipo){
    var color = tipo ? (tipo.toLowerCase().includes("ejecutando")?"#2196f3":
                    tipo.toLowerCase().includes("finalizada")?"#4caf50":
                            tipo.toLowerCase().includes("error")?"#f50057":null) : null;
    var icon = tipo ? ( tipo.toLowerCase().includes("ejecutando")?<ChevronRight style={color?{color:color, borderColor:color}:null}/>:
                    tipo.toLowerCase().includes("finalizada")?<Check style={color?{color:color, borderColor:color}:null}/>:
                            tipo.toLowerCase().includes("error")?<Close style={color?{color:color, borderColor:color}:null}/>:null) : null;
    
    return <Chip
        icon={icon?icon:null}
        label={tipo}
        style={color?{color:color, borderColor:color}:null}
        variant="outlined"
      />
}